"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ErxReport = void 0;
require("./erx-report.less");
require("ag-grid-community/dist/styles/ag-grid.css");
require("ag-grid-community/dist/styles/ag-theme-balham.css");
const ag_grid_react_1 = require("ag-grid-react");
const mobx_react_1 = require("mobx-react");
const erx_header_1 = require("./components/erx-header");
const mobx_1 = require("mobx");
const permissions_1 = require("shared/permissions");
const button_1 = require("client/components/material/button");
const checkbox_1 = require("client/components/material/checkbox/checkbox");
const date_picker_1 = require("client/components/material/date-picker/date-picker");
const select_1 = require("client/components/material/select");
const text_field_1 = require("client/components/material/text-field");
const modal_1 = require("client/components/modal");
const number_formatter_1 = require("../claim-analytics/number-formatter");
const store_1 = require("client/modules/orders/store");
const store_2 = require("client/modules/reporting/store");
const store_3 = require("client/modules/sites/modules/sites-list/store");
const transaction_details_1 = require("client/modules/orders/modules/orders-detail/components/order-claims/transaction-details"); // E-084
const store_4 = require("client/modules/users/store");
const moment = require("moment");
const React = require("react");
const JSZip = require("jszip"); // E-084
const file_saver_1 = require("file-saver"); // E-084
const ui_1 = require("../../../../../../../components/ui"); // E-084
const icons_1 = require("../../../../../../../components/icons"); // E-084
let ErxReport = class ErxReport extends React.Component {
    constructor(props) {
        super(props);
        this.queryType = "1";
        this.showQueryManager = true;
        this.erxLogData = []; // B-096.2
        this.loadingText = false; // B-096.2
        this.selectedRawData = []; // E-084
        this.selectedFinalData = []; // E-084
        this.onRetryCLaim = true; // E-084
        this.onGenerateZip = false; // E-084
        this.hasE1Selection = false;
        this.query = {
            b1: true,
            b2: true,
            e1: true,
            end: new Date(),
            siteId: "0",
            rxId: "",
            start: moment(new Date()).subtract(60, "days")
        };
        this.createHeaderButton = (text, onClick) => {
            const button = (React.createElement("button", { onClick: onClick, style: { marginLeft: "2em" }, type: "button" }, text));
            return button;
        };
        this.compareUsDateStrings = (a, b) => {
            const aTime = this.toUsDateTimestamp(a);
            const bTime = this.toUsDateTimestamp(b);
            if (aTime === bTime)
                return 0;
            if (aTime === null)
                return -1;
            if (bTime === null)
                return 1;
            return aTime < bTime ? -1 : 1;
        };
        this.toUsDateTimestamp = (value) => {
            if (!value || typeof value !== "string")
                return null;
            const dateParts = value.split("/");
            if (dateParts.length !== 3)
                return null;
            const month = Number(dateParts[0]);
            const day = Number(dateParts[1]);
            const year = Number(dateParts[2]);
            if (!month || !day || !year)
                return null;
            const parsed = new Date(year, month - 1, day).getTime();
            return Number.isNaN(parsed) ? null : parsed;
        };
        this.compareUsTimeStrings = (a, b) => {
            const aSeconds = this.toUsTimeSeconds(a);
            const bSeconds = this.toUsTimeSeconds(b);
            if (aSeconds === bSeconds)
                return 0;
            if (aSeconds === null)
                return -1;
            if (bSeconds === null)
                return 1;
            return aSeconds < bSeconds ? -1 : 1;
        };
        this.toUsTimeSeconds = (value) => {
            if (!value || typeof value !== "string")
                return null;
            const match = value.trim().match(/^(\d{1,2}):(\d{2}):(\d{2})\s*(AM|PM)$/i);
            if (!match)
                return null;
            let hours = Number(match[1]);
            const minutes = Number(match[2]);
            const seconds = Number(match[3]);
            const meridiem = match[4].toUpperCase();
            if (Number.isNaN(hours) ||
                Number.isNaN(minutes) ||
                Number.isNaN(seconds) ||
                hours < 1 ||
                hours > 12 ||
                minutes < 0 ||
                minutes > 59 ||
                seconds < 0 ||
                seconds > 59) {
                return null;
            }
            if (hours === 12) {
                hours = meridiem === "AM" ? 0 : 12;
            }
            else if (meridiem === "PM") {
                hours += 12;
            }
            return hours * 3600 + minutes * 60 + seconds;
        };
        this.adjustDate = () => {
            const start = moment(this.query.start);
            const upperMax = moment(start).add(60, "days");
            const end = moment(this.query.end);
            if (upperMax.isBefore(end)) {
                mobx_1.extendObservable(this.query, { end: upperMax });
            }
        };
        this.genDate = (type) => {
            const title = type.replace(/\b\w/g, c => c.toUpperCase());
            const jsx = (React.createElement("div", { style: { paddingRight: "1em" } },
                React.createElement("h3", null,
                    title,
                    " Date: "),
                React.createElement(date_picker_1.MaterialDatePicker, { label: `${title} Date`, required: true, value: this.query[type] || "", onChange: val => {
                        mobx_1.extendObservable(this.query, { [type]: val });
                        this.adjustDate();
                    } }),
                React.createElement("div", { style: { display: "flex", marginTop: "1em" } },
                    React.createElement(button_1.MaterialButton, { primary: true, onClick: () => {
                            mobx_1.extendObservable(this.query, { [type]: new Date() });
                            this.adjustDate();
                        }, style: { marginRight: "1em" } }, "Today"),
                    React.createElement(button_1.MaterialButton, { onClick: () => {
                            mobx_1.extendObservable(this.query, { [type]: null });
                        } }, "Clear"))));
            return jsx;
        };
        this.renderQueryModal = () => {
            if (this.showQueryManager) {
                const missingDates = !this.query.start || !this.query.end;
                const noTransactionTypesSelected = !this.query.b1 && !this.query.b2 && !this.query.e1;
                const queryType = (React.createElement(select_1.MaterialSelect, { options: [
                        { id: 1, label: "Date", value: "1" },
                        { id: 2, label: "Rx Number and Pharmacy", value: "2" }
                    ], onSelect: v => {
                        this.queryType = v;
                        this.query.siteId = "0";
                        this.query.rxId = "";
                    }, label: "Search By", value: this.queryType }));
                // Cast to any to bypass material-ui v1 withStyles/withTheme HOC type inference issues
                // (classes prop is injected at runtime; ReactNode mismatch is a @types/react version collision)
                const ErxCheckbox = checkbox_1.MaterialCheckbox;
                const transactionTypeCheckboxes = (React.createElement("div", { style: { marginTop: "1em", marginBottom: "1em" } },
                    React.createElement("h3", { style: { marginTop: 0, marginBottom: "0.75em" } }, "Transaction Types"),
                    React.createElement("div", { style: { display: "flex", flexDirection: "column" } },
                        React.createElement(ErxCheckbox, { checked: this.query.b1 || false, label: "B1 (Insurance Eligibility)", onAction: () => {
                                mobx_1.extendObservable(this.query, { b1: !this.query.b1 });
                            } }),
                        React.createElement(ErxCheckbox, { checked: this.query.b2 || false, label: "B2 (Pharmacy Benefit)", onAction: () => {
                                mobx_1.extendObservable(this.query, { b2: !this.query.b2 });
                            } }),
                        React.createElement(ErxCheckbox, { checked: this.query.e1 || false, label: "E1 (Patient Eligibility)", onAction: () => {
                                mobx_1.extendObservable(this.query, { e1: !this.query.e1 });
                            } }))));
                const rxField = (React.createElement(text_field_1.MaterialTextField, { className: "rxfield", onChange: (_, v) => {
                        this.query.rxId = v;
                    }, label: "Rx Number", value: this.query.rxId }));
                const pharmacySelect = (React.createElement(select_1.MaterialSelect, { options: this.availableOptions, onSelect: v => {
                        this.query.siteId = v;
                    }, label: "Pharmacy", value: this.query.siteId }));
                const cancelButton = (React.createElement(button_1.MaterialButton, { style: { marginLeft: "1em" }, onClick: () => {
                        this.showQueryManager = false;
                    } }, "Cancel"));
                /** REMOVE AFTER LIVE UPDATE */
                const devButton = (React.createElement(button_1.MaterialButton, { disabled: missingDates, onClick: async () => {
                        this.showQueryManager = false;
                        // await reportsStore.loadErxReportTemp(this.query);
                    }, primary: true }, "transactionStatus Script"));
                const submitButton = (React.createElement(button_1.MaterialButton, { disabled: missingDates || noTransactionTypesSelected, onClick: async () => {
                        this.showQueryManager = false;
                        await store_2.reportsStore.loadErxReport(this.query);
                    }, primary: true, title: noTransactionTypesSelected ? "Please select at least one transaction type" : "" }, "Submit"));
                const buttons = [submitButton, cancelButton];
                if (store_4.usersStore.user.value.groupId === permissions_1.GROUPS.DEV)
                    buttons.push(devButton);
                const displayRx = (React.createElement("div", { style: { display: "flex" } },
                    rxField,
                    pharmacySelect));
                const displayDate = (React.createElement("div", null,
                    React.createElement("p", null, "Start and end date must be within a range of 60 days."),
                    React.createElement("div", { style: { display: "flex" } },
                        this.genDate("start"),
                        this.genDate("end"))));
                const modal = (React.createElement(modal_1.Modal, { buttons: buttons, onCancel: () => {
                        this.showQueryManager = false;
                    }, overflowY: true },
                    queryType,
                    transactionTypeCheckboxes,
                    React.createElement("p", null, this.queryType === "1" ? displayDate : displayRx)));
                return modal;
            }
        };
        this.renderTransactionModal = () => {
            if (!this.transactionData)
                return;
            const { requests, responses, rxId, siteName: name, timezone } = this.transactionData;
            const missingProps = {
                order: { site: { name, timezone } },
                rxId: { rxId }
            };
            const selectedRow = Object.assign(Object.assign({}, this.transactionData), missingProps);
            selectedRow.requests = JSON.parse(requests);
            selectedRow.responses = JSON.parse(responses);
            return (React.createElement(transaction_details_1.TransactionDetails, { claim: selectedRow, erxLog: this.erxLogData, onCancel: () => {
                    this.transactionData = null;
                } }));
        };
        // E-063 // E-084
        this.onButtonExport = () => {
            let params = {};
            if (this.storeData.gridApi.getSelectedRows().length > 0) {
                params = {
                    fileName: "ERX Log.csv",
                    onlySelected: this.storeData.gridApi.getSelectedRows() ? true : false
                };
            }
            else {
                params = {
                    fileName: "ERX Log.csv"
                };
            }
            this.storeData.gridApi.exportDataAsCsv(params);
        };
        /**
       * get erx data while click on view claim data. B-096.2
       * function is used to get the each and every ERX tranmission date and time
       */
        this.getErxDataOnView = async (claimId) => {
            var _a;
            this.onRetryCLaim = false; // B-096.2
            let filteredData = [];
            const result = await store_1.ordersStore.readERXLog(claimId); //B-096.2
            const erxLogs = result.value; //B-096.2
            (_a = (erxLogs || [])) === null || _a === void 0 ? void 0 : _a.map((item) => {
                var _a;
                (_a = (erxLogs || [])) === null || _a === void 0 ? void 0 : _a.filter((data) => {
                    if (item.id === data.logReference) {
                        filteredData.push(item, data);
                    }
                });
            });
            this.erxLogData = filteredData || []; //B-096.2
            this.onRetryCLaim = true; // B-096.2
        };
        this.onRowClicked = async (row) => {
            const { data } = row;
            // Check if this is an E1 transaction (patient-referenced)
            if (data.erxCategory === 'e1') {
                // Navigate to patient page in new tab
                window.open(`/patients/${data.patientId}`, "_blank");
                return;
            }
            // For B1/B2, use existing logic
            this.loadingText = true; // B-096.2
            const transactionData = await store_1.ordersStore.loadTransactionData(data.claimId);
            await this.getErxDataOnView(transactionData.claimId); //B-096.2
            this.transactionData = transactionData;
        };
        /**
         * E-084 handle slection of claim data while click on row
         * @param row
         */
        this.onRowSelected = async (row) => {
            this.loadingText = false; // B-096.2
            let rowData = this.selectedRawData || [];
            const { data } = row;
            const selectedRows = this.storeData.gridApi
                ? this.storeData.gridApi.getSelectedRows()
                : [];
            this.hasE1Selection = selectedRows.some((item) => item.erxCategory === "e1");
            if (row.node.isSelected()) {
                if (data.erxCategory === "e1") {
                    this.selectedRawData = rowData;
                    return;
                }
                if (!rowData.some((item) => item.claimId === data.claimId)) {
                    let raw = await store_1.ordersStore.loadTransactionData(data.claimId);
                    if (raw)
                        rowData.push(raw);
                }
            }
            else {
                rowData = rowData.filter((item) => item.claimId !== data.claimId);
            }
            this.selectedRawData = rowData;
        };
        /**
         * E-084 handle to format raw selected claim data
         * @returns
         */
        this.formateTheRawDataForPDFExport = () => {
            let data = [];
            if (!this.selectedRawData)
                return;
            for (let i = 0; i < this.selectedRawData.length; i++) {
                const { requests, responses, rxId, siteName: name, timezone } = this.selectedRawData[i];
                const missingProps = {
                    order: { site: { name, timezone } },
                    rxId: { rxId }
                };
                const selectedRow = Object.assign(Object.assign({}, this.selectedRawData[i]), missingProps);
                selectedRow.requests = JSON.parse(requests);
                selectedRow.responses = JSON.parse(responses);
                data.push(selectedRow);
            }
            this.selectedFinalData = data;
        };
        /**
         * E-084 handle to convert selected claim data to PDF
         */
        this.onClickPDFBtnHead = async () => {
            var _a, _b;
            if (this.hasE1Selection) {
                alert("PDF export is only available for B1/B2 rows. Please unselect E1 rows.");
                return;
            }
            this.formateTheRawDataForPDFExport();
            const zip = new JSZip();
            const pdfPromises = [];
            // Reset the zip content to ensure new files are added
            this.storeZipContent = null; // Clear previous content
            if (this.selectedFinalData.length) {
                this.onRetryCLaim = false;
                const claimName = [];
                for (const claim of this.selectedFinalData) {
                    try {
                        const pdfDocGenerator = await transaction_details_1.transactionDetailsPdf(claim, "reversalErxReport");
                        claimName.push((_b = (_a = pdfDocGenerator === null || pdfDocGenerator === void 0 ? void 0 : pdfDocGenerator.docDefinition) === null || _a === void 0 ? void 0 : _a.info) === null || _b === void 0 ? void 0 : _b.title);
                        const pdfBlobPromise = new Promise((resolve, reject) => {
                            pdfDocGenerator.getBlob((blob) => {
                                if (blob) {
                                    resolve(blob);
                                }
                                else {
                                    reject(new Error("Failed to generate PDF blob"));
                                }
                            });
                        });
                        // Push the promise to the array
                        pdfPromises.push(pdfBlobPromise);
                    }
                    catch (error) {
                        console.error("Error generating PDF for claim:", error);
                    }
                }
                try {
                    // Await all PDF blobs
                    const pdfBlobs = await Promise.all(pdfPromises);
                    // Add each PDF blob to the zip
                    pdfBlobs.forEach((blob, index) => {
                        zip.file(`${claimName[index]}.pdf`, blob);
                    });
                    // Generate the zip file and trigger download
                    const content = await zip.generateAsync({ type: "blob" });
                    this.storeZipContent = content; // Store the new zip content
                }
                catch (error) {
                    alert("Something went wrong!!");
                    console.error("Error generating PDFs or ZIP:", error);
                    this.onRetryCLaim = true;
                }
                this.onRetryCLaim = true;
                this.onGenerateZip = true;
            }
            this.selectedRawData = []; // C-038.1
        };
        this.downloadZipFiles = async () => {
            if (this.storeZipContent) {
                file_saver_1.saveAs(this.storeZipContent, "ClaimsData.zip");
                this.selectedFinalData = []; // Clear selected data after download
                this.storeZipContent = null; // Reset the zip content
                this.onGenerateZip = false;
            }
            else {
                alert("No files to download.");
            }
        };
        this.storeData = {
            columnDefs: [
                {
                    checkboxSelection: true,
                    enableRowGroup: true,
                    width: 300,
                    field: "siteName",
                    filter: "agTextColumnFilter",
                    headerCheckboxSelection: true,
                    headerName: "Pharmacy Name"
                },
                {
                    field: "date",
                    comparator: (a, b) => this.compareUsDateStrings(a, b),
                    filter: "agDateColumnFilter",
                    filterParams: {
                        browserDatePicker: true,
                        comparator: (filterLocalDateAtMidnight, cellValue) => {
                            const dateAsString = cellValue;
                            if (dateAsString === null)
                                return -1;
                            const dateParts = dateAsString.split("/");
                            const cellDate = new Date(Number(dateParts[2]), Number(dateParts[0]) - 1, Number(dateParts[1]));
                            return filterLocalDateAtMidnight.getTime() === cellDate.getTime()
                                ? 0
                                : cellDate < filterLocalDateAtMidnight
                                    ? -1
                                    : 1;
                        }
                    },
                    headerName: "Date"
                },
                {
                    field: "erxTime",
                    comparator: (a, b) => this.compareUsTimeStrings(a, b),
                    filter: "agTextColumnFilter",
                    headerName: "Time (EST)"
                },
                {
                    field: "dateOfService",
                    comparator: (a, b) => this.compareUsDateStrings(a, b),
                    filter: "agDateColumnFilter",
                    filterParams: {
                        browserDatePicker: true,
                        comparator: (filterLocalDateAtMidnight, cellValue) => {
                            const dateAsString = cellValue;
                            if (!dateAsString)
                                return -1;
                            const dateParts = dateAsString.split("/");
                            const cellDate = new Date(Number(dateParts[2]), Number(dateParts[0]) - 1, Number(dateParts[1]));
                            return filterLocalDateAtMidnight.getTime() === cellDate.getTime()
                                ? 0
                                : cellDate < filterLocalDateAtMidnight
                                    ? -1
                                    : 1;
                        }
                    },
                    headerName: "Date of Service"
                },
                {
                    field: "patientId",
                    filter: "agTextColumnFilter",
                    headerName: "Patient ID",
                    valueGetter: (params) => {
                        if (params.data && params.data.erxCategory === "e1") {
                            return params.data.patientId || "";
                        }
                        return "";
                    }
                },
                {
                    field: "orderId",
                    filter: "agTextColumnFilter",
                    headerName: "Order ID",
                    valueGetter: (params) => {
                        // Show orderId only for B1/B2, empty for E1
                        if (params.data && params.data.erxCategory === "e1") {
                            return "";
                        }
                        return params.data.orderId || "";
                    }
                },
                {
                    enableRowGroup: true,
                    field: "rxId",
                    filter: "agTextColumnFilter",
                    headerName: "Rx Number",
                    valueGetter: (params) => {
                        // Show rxId only for B1/B2, empty for E1
                        if (params.data && params.data.erxCategory === "e1") {
                            return "";
                        }
                        return params.data.rxId || "";
                    }
                },
                {
                    field: "erxCategory",
                    filter: "agTextColumnFilter",
                    headerName: "Category",
                    width: 100
                },
                {
                    field: "erxOutgoing",
                    filter: "agTextColumnFilter",
                    headerName: "Type",
                    valueGetter: (params) => params.data.erxOutgoing ? "Request" : "Response",
                    width: 100
                },
                {
                    field: "transactionStatus",
                    filter: "agTextColumnFilter",
                    headerName: "Transaction Status"
                },
                {
                    field: "erxLog",
                    filter: "agTextColumnFilter",
                    headerName: "Payload"
                }
            ],
            defaultColDef: {
                comparator: (a, b) => typeof a === "string"
                    ? a.localeCompare(b)
                    : a > b
                        ? 1
                        : a < b
                            ? -1
                            : 0,
                enablePivot: true,
                enableRowGroup: true,
                enableValue: true,
                filter: true,
                resizable: true,
                sortable: true
            },
            floatingFilter: true,
            frameworkComponents: {
                numberFormatter: number_formatter_1.NumberFormatter
            },
            multiSortKey: "ctrl",
            rowData: [],
            rowSelection: "multiple"
        };
    }
    get availableOptions() {
        const options = [];
        const isImbUser = store_4.usersStore.user.value.user;
        if (isImbUser) {
            if (store_3.sitesListStore.sites.value) {
                options.push({ id: 0, label: "All Pharmacies", value: "0" });
                store_3.sitesListStore.sites.value.forEach((site, i) => {
                    const indexStandardizer = 1;
                    options.push({
                        id: i + indexStandardizer,
                        label: site.displayName || site.name,
                        value: site.id.toString()
                    });
                });
            }
        }
        else {
            const { site } = store_4.usersStore.user.value;
            const siteOption = {
                id: site.id,
                label: site.displayName || site.name,
                value: site.id.toString()
            };
            options.push(siteOption);
        }
        return options;
    }
    async componentDidMount() {
        await store_3.sitesListStore.loadSitesNoRelation();
    }
    componentWillUnmount() {
        store_2.reportsStore.erxData = null;
    }
    render() {
        const buttons = [];
        const storeData = store_2.reportsStore.erxData;
        this.storeData.rowData = storeData;
        const pushBtn = (btn) => buttons.push(btn);
        const mkBtn = (text, onClick) => pushBtn(this.createHeaderButton(text, onClick));
        mkBtn("Edit Search", () => {
            this.showQueryManager = true;
        });
        const header = React.createElement(erx_header_1.ERXHeader, { buttons: buttons, title: "ERX Log" });
        //B-096.2
        if (!this.onRetryCLaim) {
            return (React.createElement(React.Fragment, null,
                header,
                React.createElement("br", null),
                React.createElement("div", { style: { display: "float", marginLeft: "50%", marginTop: "10%" } },
                    React.createElement(ui_1.UiLoadingIndicator, null),
                    React.createElement("div", null, this.loadingText ? "Loading..." : "Generating PDF...")),
                this.renderQueryModal()));
        } // E-084
        const agGrid = (React.createElement("div", { className: "ag-theme-balham", style: {
                height: "85%",
                width: "100%"
            } },
            React.createElement("div", { style: { display: "flex" }, className: "" },
                React.createElement("button", { type: "button", onClick: this.onButtonExport.bind(this) }, "Export to CSV"),
                React.createElement("div", { style: {
                        display: "flex",
                        flexDirection: "row",
                        alignItems: "center",
                        marginLeft: "37px"
                    } },
                    React.createElement("div", { style: {
                            display: "flex",
                            flexDirection: "row",
                            alignItems: "center",
                            marginLeft: "20px"
                        } },
                        React.createElement("button", { type: "button", onClick: !this.onGenerateZip
                                ? this.onClickPDFBtnHead.bind(this)
                                : this.downloadZipFiles.bind(this), disabled: !this.onGenerateZip &&
                                (!!this.hasE1Selection || !(this.selectedRawData || []).length), title: !this.onGenerateZip && !!this.hasE1Selection
                                ? "PDF export is available only for B1/B2 selections"
                                : "", style: {
                                fontWeight: this.onGenerateZip ? "bold" : "normal",
                                display: "flex",
                                alignItems: "center" // Align icon and text
                            } }, !this.onGenerateZip ? ("Export to PDF") : (React.createElement(React.Fragment, null,
                            React.createElement("span", { style: { fontWeight: "bold" } }, "Download Zip"),
                            React.createElement(icons_1.DownloadIcon, { style: { marginLeft: "5px" } }),
                            " "))),
                        !this.onGenerateZip && !!this.hasE1Selection && (React.createElement("span", { style: { marginLeft: "8px", fontSize: "12px" } }, "Select B1/B2 rows only for PDF export"))))),
            React.createElement(ag_grid_react_1.AgGridReact, { animateRows: true, columnDefs: this.storeData.columnDefs, defaultColDef: this.storeData.defaultColDef, floatingFilter: this.storeData.floatingFilter, frameworkComponents: this.storeData.frameworkComponents, groupMultiAutoColumn: true, multiSortKey: this.storeData.multiSortKey, onGridReady: params => {
                    this.storeData.gridApi = params.api;
                }, onRowClicked: this.onRowClicked, onRowSelected: this.onRowSelected, rowData: this.storeData.rowData, rowSelection: this.storeData.rowSelection, sideBar: true, suppressExcelExport: true, suppressRowClickSelection: true })));
        //  E-084  {this.formateTheRawDataForPDFExport()}
        return (React.createElement(React.Fragment, null,
            header,
            React.createElement("br", null),
            store_2.reportsStore.showLoader ? React.createElement(React.Fragment, null) : agGrid,
            this.renderTransactionModal(),
            this.formateTheRawDataForPDFExport(),
            this.renderQueryModal()));
    }
};
__decorate([
    mobx_1.observable
], ErxReport.prototype, "queryType", void 0);
__decorate([
    mobx_1.observable
], ErxReport.prototype, "showQueryManager", void 0);
__decorate([
    mobx_1.observable
], ErxReport.prototype, "erxLogData", void 0);
__decorate([
    mobx_1.observable
], ErxReport.prototype, "loadingText", void 0);
__decorate([
    mobx_1.observable
], ErxReport.prototype, "selectedRawData", void 0);
__decorate([
    mobx_1.observable
], ErxReport.prototype, "selectedFinalData", void 0);
__decorate([
    mobx_1.observable
], ErxReport.prototype, "onRetryCLaim", void 0);
__decorate([
    mobx_1.observable
], ErxReport.prototype, "onGenerateZip", void 0);
__decorate([
    mobx_1.observable
], ErxReport.prototype, "hasE1Selection", void 0);
__decorate([
    mobx_1.observable
], ErxReport.prototype, "storeZipContent", void 0);
__decorate([
    mobx_1.observable
], ErxReport.prototype, "transactionData", void 0);
__decorate([
    mobx_1.observable
], ErxReport.prototype, "query", void 0);
__decorate([
    mobx_react_1.computed
], ErxReport.prototype, "availableOptions", null);
ErxReport = __decorate([
    mobx_react_1.observer
], ErxReport);
exports.ErxReport = ErxReport;



//////////////////
// WEBPACK FOOTER
// ./src/client/modules/reporting/modules/reporting-list/components/report-container/erx-report/erx-report.tsx
// module id = 3959
// module chunks = 0